import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn as clsx } from "../../../helpers/react.js";
import '../../../assets/index3.css';const live = "_live_1o52r_2";
const delay = "_delay_1o52r_21";
const s = {
  live,
  delay
};
const LiveBadge = forwardRef(
  ({ children, showLiveIcon = true, badgeText, className }, ref) => /* @__PURE__ */ jsxs("div", { ref, className: clsx(s.live, className), children: [
    showLiveIcon && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "6", height: "6", viewBox: "0 0 6 6", fill: "none", children: /* @__PURE__ */ jsx("circle", { cx: "3", cy: "3", r: "3", fill: "#F44C30" }) }),
      badgeText
    ] }),
    /* @__PURE__ */ jsx("span", { className: s.delay, children })
  ] })
);
export {
  LiveBadge
};
